import React from 'react';

import { ClassDetail } from './ClassDetail';
import { ClassContainer } from '../../../../ClassModal/ClassContainer';

export const ClassPage = () => (
    <ClassContainer.Provider>
        <ClassDetail />
    </ClassContainer.Provider>
);
